import React, { useEffect } from 'react';
import './notification-toast.scss';
import { useNotificationToast } from './notification-toast-context';
import { SVGS } from '../assets';
import { getIsAuthenticated, useAppSelector } from '@zonofi/zono-money-store';

export const NotificationToast: React.FC = () => {
  const isAuthenticated = useAppSelector(getIsAuthenticated);
  const { notificationData, onCloseToast, showToast, onToastClick } =
    useNotificationToast();

  useEffect(() => {
    if (!showToast) return;

    const timer = setTimeout(() => {
      onCloseToast();
    }, 3000); // auto close after 3s

    return () => clearTimeout(timer);
  }, [showToast, onCloseToast]);

  const getIcon = () => {
    switch (notificationData.type) {
      case 'conversation_assignment':
        return SVGS.ConversationNotification;
      case 'sync-failed':
        return SVGS.SyncFailNotification;
      case 'download':
        return SVGS.DownloadNotification;
      default:
        return SVGS.ConversationNotification;
    }
  };

  if (!isAuthenticated || !showToast) return null;

  return (
    <div className="foreground-notification" onClick={onToastClick}>
      <img src={getIcon()} alt="notification-type" className="icon" />
      <div className="notification-content">
        <div className="title font-semibold">{notificationData.title}</div>
        <div className="body font-regular">{notificationData.body}</div>
      </div>
    </div>
  );
};
